<template>
  <div class="default-page">
    <article>
      <div class="article-head">
        <h1 class="title">Contact</h1>
      </div>
      <div class="article-content">
        <div style="height:20px" class="wp-block-spacer"></div>
        <div id="nf-form-1-cont" class="nf-form-cont" role="form">
          <div class="nf-form-wrap ninja-forms-form-wrap">
            <div class="nf-form-layout">
              <form>
                <div>
                  <div class="nf-before-form-content">
                    <div class="nf-form-fields-required">
                      Fields marked with an
                      <span class="ninja-forms-req-symbol">*</span>
                      are required
                    </div>
                  </div>
                  <div class="nf-form-content">
                    <div class="nf-field-container textbox-container  label-above ">
                      <div class="nf-field">
                        <div class="field-wrap textbox-wrap" :class="{'nf-error': nameEmpty, 'nf-pass': nameSuccess}">
                          <div class="nf-field-label">
                            <label for="nf-field-1" id="nf-label-field-1" class="">Name <span
                                class="ninja-forms-req-symbol">*</span> </label>
                          </div>
                          <div class="nf-field-element">
                            <input type="text" value="" class="ninja-forms-field nf-element" id="nf-field-1"
                                   name="nf-field-1" aria-invalid="false" aria-describedby="nf-error-1"
                                   aria-labelledby="nf-label-field-1" v-model="names" @blur="inputBlur('name')" @keyup="inputChange('name')">
                          </div>
                        </div>
                      </div>
                      <div class="nf-after-field" v-if="nameEmpty">
                        <div class="nf-input-limit"></div>
                        <div id="nf-error-1" class="nf-error-wrap nf-error" role="alert"><div class="nf-error-msg nf-error-required-error">This is a required field.</div></div>
                      </div>
                    </div>
                    <div id="nf-field-2-container" class="nf-field-container email-container  label-above ">
                      <div class="nf-before-field"></div>
                      <div class="nf-field">
                        <div id="nf-field-2-wrap" :class="{ 'nf-error': emailEmpty, 'nf-pass': emailSuccess }" class="field-wrap email-wrap" data-field-id="2">
                          <div class="nf-field-label"><label for="nf-field-2" id="nf-label-field-2" class="">Email <span
                              class="ninja-forms-req-symbol">*</span> </label></div>
                          <div class="nf-field-element">
                            <input type="email" value="" class="ninja-forms-field nf-element" id="nf-field-2"
                                   name="email" autocomplete="email" aria-invalid="false" aria-describedby="nf-error-2"
                                   aria-labelledby="nf-label-field-2" v-model="email" @blur="inputBlur('email')" @keyup="inputChange('email')">
                          </div>
                        </div>
                      </div>
                      <div class="nf-after-field" v-if="emailEmpty">
                        <div class="nf-input-limit"></div>
                        <div id="nf-error-2" class="nf-error-wrap nf-error" role="alert"><div class="nf-error-msg nf-error-required-error">This is a required field.</div></div>
                      </div>
                    </div>
                    <div id="nf-field-3-container" class="nf-field-container textarea-container  label-above ">
                      <div class="nf-before-field"></div>
                      <div class="nf-field">
                        <div id="nf-field-3-wrap" :class="{ 'nf-error': messageEmpty, 'nf-pass': messageSuccess }" class="field-wrap textarea-wrap" data-field-id="3">
                        <div class="nf-field-label"><label for="nf-field-3" id="nf-label-field-3" class="">Message <span class="ninja-forms-req-symbol">*</span> </label></div>
                        <div class="nf-field-element">
                          <textarea id="nf-field-3" name="nf-field-3" aria-invalid="false" aria-describedby="nf-error-3" class="ninja-forms-field nf-element" aria-labelledby="nf-label-field-3" v-model="message" @blur="inputBlur('message')" @keyup="inputChange('message')"></textarea>
                        </div>
                      </div></div>
                      <div class="nf-after-field" v-if="messageEmpty">
                        <div class="nf-input-limit"></div>
                        <div id="nf-error-3" class="nf-error-wrap nf-error" role="alert"><div class="nf-error-msg nf-error-required-error">This is a required field.</div></div>
                      </div>
                    </div>
                    <div id="nf-field-4-container" class="nf-field-container submit-container  label-above  textbox-container">
                      <div class="nf-before-field"></div>
                      <div class="nf-field">
                        <div id="nf-field-4-wrap" class="field-wrap submit-wrap textbox-wrap" data-field-id="4">
                          <div class="nf-field-label"></div>
                          <div class="nf-field-element">
                            <input id="nf-field-4" class="ninja-forms-field nf-element " type="button" value="Submit" disabled="">
                          </div>
                          <div class="nf-error-wrap"></div>
                        </div>
                      </div>
                      <div class="nf-after-field">
                        <div class="nf-input-limit"></div>
                        <div id="nf-error-4" class="nf-error-wrap nf-error" role="alert"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: "contact",
  data() {
    return {
      nameEmpty: false,
      nameSuccess: false,
      emailEmpty: false,
      emailSuccess: false,
      messageEmpty: false,
      messageSuccess: false,
      names: "",
      email: "",
      message: ""
    }
  },
  methods: {
    inputBlur(type) {
      if (type === "name") {
        !this.names && (this.nameEmpty = true);
      } else if (type === "email") {
        !this.email && (this.emailEmpty = true);
      } else if (type === "message") {
        !this.message && (this.messageEmpty = true);
      }
    },
    inputChange(type) {
      console.log("inputChange", type, this.names);
      if (type === "name") {
        this.nameEmpty = !this.names;
        this.nameSuccess = !!this.names;
      } else if (type === "email") {
        this.emailEmpty = !this.email;
        this.emailSuccess = !!this.email;
      } else if (type === "message") {
        this.messageEmpty = !this.message;
        this.messageSuccess = !!this.message;
      }
    }
  }
}
</script>

<style scoped>
.nf-form-content label {
  font-size: 18px;
  line-height: 20px;
  font-weight: 700;
  margin: 0;
  padding: 0;
}
.label-above .nf-field-element, .label-below .nf-field-element {
  margin: 0;
  width: 100%;
  order: 15;
  position: relative;
}
.nf-form-content .list-select-wrap .nf-field-element>div, .nf-form-content input:not([type=button]), .nf-form-content textarea {
  background: #f7f7f7;
  border: 1px solid #c4c4c4;
  border-radius: 0;
  box-shadow: none;
  color: #787878;
  transition: all .5s;
}
.label-above .field-wrap, .label-below .field-wrap {
  flex-direction: column;
  flex-flow: wrap;
}
.field-wrap {
  display: flex;
}
.nf-form-content {
  padding: 5px;
  max-width: 1000px;
  margin: 0 auto;
}
.default-page {
  padding-top: 150px;
  padding-bottom: 130px;
}
.default-page .article-head {
  position: relative;
  display: block;
  width: 100%;
  max-width: 570px;
  margin: 0 auto;
  padding: 0 15px;
  z-index: 2;
}
.default-page .article-head .title {
  margin-top: 0;
  margin-bottom: 0.55em;
  color: #000;
  font-family: TiemposHeadline,serif;
  font-size: 55px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
}
@media only screen and (max-width: 1199px) {
  .default-page .article-head .title {
    font-size: 52px;
  }
}

@media only screen and (max-width: 991px) {
  .default-page .article-head .title {
    font-size: 44px;
  }
}
.default-page .article-content {
  position: relative;
  display: block;
  width: 100%;
  max-width: 570px;
  margin: 0 auto;
  padding: 0 15px;
  font-size: 16px;
  font-weight: 400;
  line-height: 2;
  z-index: 2;
}
.nf-form-content .listselect-wrap .nf-field-element div, .nf-form-content input.ninja-forms-field, .nf-form-content select.ninja-forms-field:not([multiple]) {
  height: 50px;
}
.nf-form-content .listselect-wrap .nf-field-element div, .nf-form-content .ninja-forms-field {
  font-size: 16px;
  margin: 0;
  padding: 12px;
}
.nf-field-element input, .nf-field-element select, .nf-field-element textarea {
  margin: 0;
  width: auto;
  height: auto;
  vertical-align: inherit;
}
.field-wrap .pikaday__container, .field-wrap .pikaday__display, .field-wrap>div input, .field-wrap select, .field-wrap textarea {
  width: 100%;
}
.nf-form-content textarea.ninja-forms-field {
  height: 200px;
}
.nf-form-content .listselect-wrap .nf-field-element div, .nf-form-content .ninja-forms-field {
  font-size: 16px;
  margin: 0;
  padding: 12px;
}
.field-wrap>div input[type=checkbox], .field-wrap button, .field-wrap input[type=button], .field-wrap input[type=submit] {
  width: auto;
}
.nf-form-content button, .nf-form-content input[type=button], .nf-form-content input[type=submit] {
  background: #333;
  border: 0;
  color: #f7f7f7;
  transition: all .5s;
}
.nf-form-content button:hover, .nf-form-content input[type=button]:hover, .nf-form-content input[type=submit]:hover {
  background: #c4c4c4;
  color: #787878;
  transition: all .5s
}
.nf-error-msg, .ninja-forms-req-symbol {
  color: #e80000;
}
#ninja_forms_required_items, .nf-field-container {
  clear: both;
  position: relative;
  margin-bottom: 25px;
}
.nf-error .ninja-forms-field {
  border-color: #e80000!important;
  transition: all .5s;
}
.nf-error.field-wrap .nf-field-element:after {
  background: #e80000;
  color: #fff;
  font-family: FontAwesome;
  font-size: 20px;
  content: "!";
  position: absolute;
  top: 1px;
  right: 1px;
  bottom: 1px;
  height: 48px;
  width: 50px;
  line-height: 50px;
  text-align: center;
  transition: all .5s;
}
.nf-pass.field-wrap .nf-field-element:after {
  color: green;
  font-family: FontAwesome;
  font-size: 30px;
  content: "✓";
  position: absolute;
  top: 0;
  right: 16px;
  height: 50px;
  line-height: 50px;
  transition: all .5s;
}
</style>
